const exicons = {
  ems: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/EMS.jpg',
  wanxiang: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E4%B8%87%E8%B1%A1.jpg',
  dongjun: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E4%B8%9C%E9%AA%8F.jpg',
  zhongtong: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E4%B8%AD%E9%80%9A.jpg',
  jingdong: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E4%BA%AC%E4%B8%9C.jpg',
  jd: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E4%BA%AC%E4%B8%9C.jpg',
  uc: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E4%BC%98%E9%80%9F.jpg',
  quanfeng: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%85%A8%E5%B3%B0.jpg',
  pingjun: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%93%81%E9%AA%8F.jpg',
  vip: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%94%AF%E5%93%81%E4%BC%9A.jpg',
  yuantong: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%9C%86%E9%80%9A.jpg',
  guotong: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%9B%BD%E9%80%9A.jpg',
  tiantian: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%A4%A9%E5%A4%A9.jpg',
  tmall: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%A4%A9%E7%8C%AB.jpg',
  zaijisong: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%AE%85%E6%80%A5%E9%80%81.jpg',
  anneng: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%AE%89%E8%83%BD.jpg',
  debang: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%BE%B7%E9%82%A6.jpg',
  kuaijie: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%BF%AB%E6%8D%B7.jpg',
  default: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%BF%AB%E9%80%92%E8%BF%90%E8%BE%93.png',
  shengtong: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E7%94%B3%E9%80%9A.jpg',
  baishi: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E7%99%BE%E4%B8%96.jpg',
  suning: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E8%8B%8F%E5%AE%81.jpg',
  youzheng: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E9%82%AE%E6%94%BF.jpg',
  yunda: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E9%9F%B5%E8%BE%BE.jpg',
  shunfeng: 'http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E9%A1%BA%E4%B8%B0.jpg',
  zy: 'https://assets-bbg.oss-cn-hangzhou.aliyuncs.com/349ae87c06283cf9cb67803ab09f4243.jpg',
  cainiao: 'https://assets-bbg.oss-cn-hangzhou.aliyuncs.com/eaf81a4c510fd9f9d72a9c2c1c67c32a2834349b0e69.jpeg',
  jtexpress: 'https://cdn.kuaidi100.com/images/all/56/jtexpress.png',
  huitongkuaidi: "http://assets-yb.oss-cn-beijing.aliyuncs.com/exicon/%E5%A4%A9%E7%8C%AB.jpg",
};
export default exicons;
